import { Center, Spinner, VStack, Text, Box } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useUserStore } from '@store/app.store';

import { connectZoomAccount } from '@services/zoom.service';

export default function ZoomConnectPage() {
  const user = useUserStore((state) => state.user);

  useEffect(() => {
    const handleZoomConnection = () => {
      if (!user) return;

      connectZoomAccount();
    };

    handleZoomConnection();
  }, [user]);

  // Show loading state while processing
  return (
    <Box data-cy='zoom-connect-page'>
      <Center pt={10}>
        <VStack gap={6}>
          <Text fontSize='lg'>Connecting to Zoom...</Text>
          <Spinner size='xl' />
        </VStack>
      </Center>
    </Box>
  );
}
